/**
 * Accès aux panneaux Lab (issus de DozLab) — v1 réservée au superadmin
 * (product owner Dozka).
 *
 * Gate sur `isSuperadmin` — MÊME source que le contrôle backend
 * (`session.is_superadmin` sur `/api/prod|pipeline|prompts/*`), donc front et
 * back s'accordent par construction, quel que soit l'email du compte owner.
 * Même idiome que `panels/metrics/access.ts` (`useCanUseMetrics`) et
 * `channels/access.ts` (`useCanUseChannels`).
 */
import { useSession } from "@/core/auth/useSession";

export function useCanUseLab(): boolean {
  const { user } = useSession();
  return user?.isSuperadmin === true;
}
